import LinkTag from '@/components/common/link-tag';
import MedicineDictionary from '@/entities/medicine-dictionary/ui/MedicineDictionary';
import { createMedicineDictionaryDetailUrl } from '@/entities/medicine-dictionary/util';
import useSearchPopularMedicineDictionaryViewModel from '../hook/useSearchPopularMedicineDictionaryViewModel';

const SearchPopularMedicineDictionary = () => {
  const viewModel = useSearchPopularMedicineDictionaryViewModel();

  return (
    <div className='px-[24px] pt-[24px] pb-[32px]'>
      <h2 className='typography-ui-20sb mb-4 text-gray-700 '>많이 검색된 약품</h2>
      <div className='grid grid-cols-1 gap-[28px] md:grid-cols-2' suppressHydrationWarning>
        {viewModel.popularMedicineDictionaryItems.map((item) => (
          <LinkTag
            key={item.getPublicId()}
            href={createMedicineDictionaryDetailUrl(item)}
            onClickNavigateToScreen={viewModel.onClickMedicineDictionary(item)}
          >
            <MedicineDictionary
              title={item.getBasicInfoName()}
              description={item.getPharmaceuticalEffectLiteracy()}
              summary={item.getWholeSummary()}
              image={item.getRepresentativeImage()}
              imageAlt={item.getSimplifiedName()}
            />
          </LinkTag>
        ))}
      </div>
    </div>
  );
};

export default SearchPopularMedicineDictionary;
